import { StyleSheet, View } from '@react-pdf/renderer';

import { ExportListItem } from '../ExportListItem.tsx';
import { ExportCostApproachData } from './types.ts';

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '3px',
  },
});

export const ExportCostApproachDataSources = ({ data }: { data: ExportCostApproachData }) => {
  const remainingLife = (data.totalEconomicLife - (data.effectiveAge ?? 0)).toFixed(0);

  return (
    <View style={styles.container}>
      <ExportListItem size="sm" text="Source of cost data: Craftsman" />
      <ExportListItem
        size="sm"
        text={`Effective date of cost data: 01/01/${data.effectiveDateYear ?? 'unknown'}`}
      />
      <ExportListItem
        size="sm"
        text={`Quality rating from cost service: ${data.quality?.toFixed(1) ?? 'unknown'}`}
      />
      <ExportListItem size="sm" text={`Est. remaining economic life: ${remainingLife} years`} />
    </View>
  );
};
